import { SDF_BORDER_RADIUS, SDF_BOX_SHADOW, SDF_COLORS, SDF_FONTS, SDF_LAYOUT, SDF_SPACING } from './sdfThemeConf';
import { createTheme } from '@material-ui/core/styles';
import { border, toCssValue } from '../themeUtils';
const sdfThemeConfiguration = {
    color: {
        primary: {
            lightest: SDF_COLORS.primary.lightest,
            light: SDF_COLORS.primary.light,
            main: SDF_COLORS.primary.main,
            dark: SDF_COLORS.primary.dark,
            darkest: SDF_COLORS.primary.darkest,
        },
        brand: {
            lightest: SDF_COLORS.brand.lightest,
            light: SDF_COLORS.brand.light,
            main: SDF_COLORS.brand.main,
            dark: SDF_COLORS.brand.dark,
            darkest: SDF_COLORS.brand.darkest,
        },
        success: {
            light: SDF_COLORS.success.light,
            main: SDF_COLORS.success.main,
            dark: SDF_COLORS.success.dark,
        },
        error: {
            lightest: SDF_COLORS.error.lightest,
            light: SDF_COLORS.error.light,
            main: SDF_COLORS.error.main,
            dark: SDF_COLORS.error.dark,
        },
        warning: {
            lightest: SDF_COLORS.warning.lightest,
            light: SDF_COLORS.warning.light,
            main: SDF_COLORS.warning.main,
        },
        grey: {
            lightest: SDF_COLORS.grey.lightest,
            light: SDF_COLORS.grey.light,
            default: SDF_COLORS.grey.default,
            dark: SDF_COLORS.grey.dark,
            darkest: SDF_COLORS.grey.darkest,
        },
        input: {
            placeholder: SDF_COLORS.grey.default,
            border: SDF_COLORS.grey.default,
        },
        background: {
            body: SDF_COLORS.background.body,
            light: SDF_COLORS.background.light,
            dark: SDF_COLORS.background.dark,
        },
        font: {
            dark: SDF_COLORS.font.dark,
            light: SDF_COLORS.font.light,
        },
        common: {
            contentHover: SDF_COLORS.common.contentHover,
        },
    },
    font: {
        family: SDF_FONTS.family,
        size: {
            small: SDF_FONTS.size.small,
            mediumSmall: SDF_FONTS.size.mediumSmall,
            medium: SDF_FONTS.size.medium,
            mediumBig: SDF_FONTS.size.mediumBig,
            big: SDF_FONTS.size.big,
            caption: SDF_FONTS.size.caption,
            title: SDF_FONTS.size.title,
            heading: SDF_FONTS.size.heading,
        },
        lineHeight: {
            small: SDF_FONTS.lineHeight.small,
            mediumSmall: SDF_FONTS.lineHeight.mediumSmall,
            medium: SDF_FONTS.lineHeight.medium,
            mediumBig: SDF_FONTS.lineHeight.mediumBig,
            big: SDF_FONTS.lineHeight.big,
        },
        weight: {
            light: SDF_FONTS.weight.light,
            normal: SDF_FONTS.weight.normal,
            bold: SDF_FONTS.weight.bold,
        },
    },
    common: {
        borderRadius: {
            low: SDF_BORDER_RADIUS.low,
            default: SDF_BORDER_RADIUS.default,
            high: SDF_BORDER_RADIUS.high,
            onlyTop: SDF_BORDER_RADIUS.onlyTop,
            onlyRight: SDF_BORDER_RADIUS.onlyRight,
        },
        shadow: {
            light: SDF_BOX_SHADOW.light,
            default: SDF_BOX_SHADOW.default,
            dark: SDF_BOX_SHADOW.dark,
        },
    },
    space: {
        layout: {
            fullWidth: SDF_SPACING.layout.fullWidth,
            partialWidth: SDF_SPACING.layout.partialWidth,
        },
        margin: {
            smallest: SDF_SPACING.margin.smallest,
            small: SDF_SPACING.margin.small,
            default: SDF_SPACING.margin.default,
            large: SDF_SPACING.margin.large,
            largest: SDF_SPACING.margin.largest,
            horizontalDefault: SDF_SPACING.margin.horizontalDefault,
            verticalDefault: SDF_SPACING.margin.verticalDefault,
        },
        padding: {
            smallest: SDF_SPACING.padding.smallest,
            small: SDF_SPACING.padding.small,
            default: SDF_SPACING.padding.default,
            large: SDF_SPACING.padding.large,
            largest: SDF_SPACING.padding.largest,
            horizontalDefault: SDF_SPACING.padding.horizontalDefault,
            verticalDefault: SDF_SPACING.padding.verticalDefault,
        },
    },
    layout: {
        width: {
            full: SDF_LAYOUT.width.full,
            partial: SDF_LAYOUT.width.partial,
        },
        sidebar: {
            full: SDF_LAYOUT.sidebar.full,
        },
        header: {
            topBar: SDF_LAYOUT.header.topBar,
            menu: SDF_LAYOUT.header.menu,
        },
    },
    components: {
        table: {
            header: {
                background: SDF_COLORS.brand.main,
                color: SDF_COLORS.font.light,
            },
            headerSecondary: {
                background: SDF_COLORS.brand.main,
                color: SDF_COLORS.font.light,
            },
            th: {
                background: SDF_COLORS.background.light,
                color: SDF_COLORS.font.dark,
            },
            row: {
                hover: SDF_COLORS.common.contentHover,
            },
        },
        link: {
            colors: {
                normal: SDF_COLORS.primary.main,
                hover: SDF_COLORS.primary.light,
            },
        },
        header: {
            colors: {
                background: SDF_COLORS.brand.main,
                text: SDF_COLORS.font.light,
                menuIcon: SDF_COLORS.font.light,
            },
        },
        menu: {
            colors: {
                background: SDF_COLORS.background.light,
                text: SDF_COLORS.font.dark,
                selected: SDF_COLORS.primary.main,
            },
        },
        tabs: {
            indicator: SDF_COLORS.brand.main,
            background: SDF_COLORS.background.light,
            color: SDF_COLORS.font.dark,
        },
        userMenu: {
            colors: {
                headerBackground: SDF_COLORS.primary.light,
                headerText: SDF_COLORS.font.dark,
                buttonBackground: SDF_COLORS.background.light,
                buttonText: SDF_COLORS.font.dark,
                buttonBackgroundHover: SDF_COLORS.primary.main,
                triggerBackground: SDF_COLORS.background.light,
                triggerText: SDF_COLORS.primary.main,
                userIconBackground: SDF_COLORS.primary.darkest,
                userIconText: SDF_COLORS.font.light,
            },
        },
        listItem: {
            backgroundHover: SDF_COLORS.background.light,
            backgroundSelected: SDF_COLORS.primary.main,
            textHover: SDF_COLORS.font.dark,
            textSelected: SDF_COLORS.font.light,
        },
        sidebar: {
            colors: {
                itemSelected: SDF_COLORS.primary.main,
                border: SDF_COLORS.primary.main,
            },
        },
        passwordSuggestionBox: {
            container: {
                background: SDF_COLORS.background.light,
                text: SDF_COLORS.font.dark,
            },
            arrow: {
                background: SDF_COLORS.background.light,
            },
            rule: {
                iconSuccess: SDF_COLORS.success.main,
                iconError: SDF_COLORS.error.main,
                text: SDF_COLORS.font.dark,
            },
        },
        logoutButton: {
            background: SDF_COLORS.grey.lightest,
            backgroundHover: SDF_COLORS.grey.light,
            text: SDF_COLORS.font.dark,
        },
    },
};
export function createMyTheme(options) {
    return createTheme({
        palette: {
            primary: {
                light: SDF_COLORS.primary.light,
                main: SDF_COLORS.primary.main,
                dark: SDF_COLORS.primary.dark,
            },
            secondary: {
                light: SDF_COLORS.brand.light,
                main: SDF_COLORS.brand.main,
                dark: SDF_COLORS.brand.dark,
            },
            text: {
                primary: SDF_COLORS.font.dark,
                secondary: SDF_COLORS.font.light,
            },
        },
        typography: {
            fontFamily: SDF_FONTS.family,
            h5: {
                fontSize: '1.25rem',
                lineHeight: '1.5',
            },
            subtitle1: {
                lineHeight: '1.25',
            },
            body1: {
                color: '#4a4a4a',
            },
            caption: {
                color: '#333',
                fontSize: '0.625rem',
            },
            h4: {
                fontSize: '1.5rem',
                fontWeight: 500,
                color: 'black',
            },
        },
        overrides: {
            MuiAutocomplete: {
                noOptions: {
                    color: SDF_COLORS.font.dark,
                    fontSize: SDF_FONTS.size.medium,
                },
            },
            MuiInput: {
                underline: {
                    '&:after, &:before': {
                        borderBottom: border('currentColor'),
                    },
                    '&:hover:not($disabled):not($focused):not($error):before': {
                        borderBottomColor: 'currentColor',
                    },
                },
            },
            MuiFormHelperText: {
                root: {
                    marginTop: 2,
                    fontSize: '0.70rem',
                    lineHeight: '0.9em',
                },
            },
            MuiFormLabel: {
                root: {
                    color: SDF_COLORS.grey.light,
                    '&$disabled': {
                        color: SDF_COLORS.font.dark,
                    },
                    '&$focused': {
                        color: SDF_COLORS.font.dark,
                    },
                },
            },
            MuiInputLabel: {
                formControl: {
                    color: SDF_COLORS.font.dark,
                },
            },
            MuiStepLabel: {
                root: {
                    textTransform: 'uppercase',
                },
                label: {
                    color: SDF_COLORS.font.dark,
                },
                completed: {
                    '&:hover': {
                        cursor: 'pointer',
                        textDecoration: 'underline',
                    },
                },
                active: {
                    fontWeight: `${SDF_FONTS.weight.bold} !important`,
                },
                '&$disabled': {
                    color: SDF_COLORS.grey.light,
                },
            },
            MuiStepIcon: {
                root: {
                    '& text': {
                        fill: SDF_COLORS.font.light,
                        fontSize: SDF_FONTS.size.mediumSmall,
                        fontWeight: SDF_FONTS.weight.bold,
                    },
                },
                completed: {
                    color: `${SDF_COLORS.primary.main} !important`,
                },
                active: {
                    color: `${SDF_COLORS.primary.main} !important`,
                },
            },
            MuiInputBase: {
                input: {
                    padding: toCssValue([7, 0, 2]),
                    fontSize: SDF_FONTS.size.mediumBig,
                },
            },
            MuiRadio: {
                root: {
                    color: SDF_COLORS.font.dark,
                },
            },
            MuiSelect: {
                select: {
                    padding: toCssValue([7, 0, 6]),
                },
            },
        },
        ...options,
    });
}
export const sdfTheme = createMyTheme(sdfThemeConfiguration);
//# sourceMappingURL=sdfTheme.js.map